import { getEllipsedString } from "../../../config/utils"

const CarRegistrationNumberPlate = ({ regNumber }) => {
    return (
        <div className='w-full flex relative'>
            <div className='flex items-center'>
                <div className='bg-[#003399] h-full flex items-center flex-col justify-center px-2 rounded-tl-sm rounded-bl-sm'>
                    <div className='rounded-full w-3 h-3 p-1 border border-dotted border-[#fab700]'></div>
                    <span className='text-[#fab700] text-[8px]'>GB</span>
                </div>
            </div>
            <div className='rounded-tr-md rounded-br-md flex-1 h-[41px] bg-[#fab700] z-20'>
                <div
                    className={`
                        flex
                        justify-center
                        items-center
                        w-full 
                        h-full 
                        rounded-tr-md 
                        rounded-br-md 
                        bg-[#fab700] 
                        outline-none 
                        pl-1
                        pr-2 
                        placeholder:text-gray-500
                        custom-input
                        uppercase
                        font-bold
                        text-sm
                    `}
                >
                    { getEllipsedString(regNumber, 7) }
                </div>
            </div>
        </div>
    )
}

export default CarRegistrationNumberPlate